import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/@Utils/amplitude";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { PLAN_NAMES, showToast } from "@Shared/@Utils/constants";
import { delay } from "@Shared/@Utils/utils";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CancelPlanConfirmation from "./modals/cancel-plan-confirmation.vue";
import AccountPlanPerks from "./account-plan-perks.vue";
import { ADD_SUBSCRIPTIONS, CANCEL_SUBSCRIPTIONS, LOAD_ACCOUNT_PLAN_DETAILS } from "../../store/account-plan-actions";
import { CURRENT_ACCOUNT_PLAN, CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import NotificationPopover from "@Shared/components/general/notification-popover";
import { COUPON, IS_CURRENT_USER_PAYER, IS_CURRENT_USER_SUBSCRIBED, PAYMENT_PLANS, HAS_CURRENT_USER_PAYMENT_METHODS, CURRENT_ACCOUNT_PLAN_INTERVAL, SUBSCRIBING_CURRENT_ACCOUNT, HAS_PAYMENT_ERROR, PAYER } from "../../store/account-plan-getters";
import { isEmpty, isObject } from "lodash";
import { SET_SUBSCRIBING_CURRENT_ACCOUNT } from "../../store/account-plan-mutations";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PlanBoxes",
  components: {
    SimpleButton,
    CancelPlanConfirmation,
    AccountPlanPerks,
    NotificationPopover
  },
  props: {
    withSession: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectingPlan: false,
      cancelingPlan: false,
      showCancelModal: false,
      planDurationMonthly: true,
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_USERNAME, CURRENT_ACCOUNT_PLAN])), mapGetters("AccountPlanStore", [IS_CURRENT_USER_PAYER, PAYER, COUPON, PAYMENT_PLANS, HAS_CURRENT_USER_PAYMENT_METHODS, IS_CURRENT_USER_SUBSCRIBED, CURRENT_ACCOUNT_PLAN_INTERVAL, SUBSCRIBING_CURRENT_ACCOUNT, HAS_PAYMENT_ERROR])), {}, {
    freePlanName() {
      return PLAN_NAMES.FREE;
    },
    isCouponEmpty() {
      return isEmpty(this.COUPON);
    },
    couponAmountText() {
      switch (this.COUPON.type) {
        case "percent":
          return `${this.COUPON.amount}%`;
        case "flat":
        default:
          return this.$options.filters.formatMoneyValue(this.COUPON.amount / 100);
      }
    },
    isSubscribing() {
      return this.selectingPlan || this.SUBSCRIBING_CURRENT_ACCOUNT;
    },
    disableSubscribe() {
      return this.loading || !this.HAS_CURRENT_USER_PAYMENT_METHODS || this.HAS_PAYMENT_ERROR || this.disableSubscribeNotPayer;
    },
    disablePlanToggle() {
      return this.loading || this.IS_CURRENT_USER_SUBSCRIBED || this.HAS_PAYMENT_ERROR || this.subscriptionWillEnd;
    },
    subscriptionWillEnd() {
      return this.CURRENT_ACCOUNT_PLAN === PLAN_NAMES.PRO && !this.IS_CURRENT_USER_SUBSCRIBED;
    },
    disableSubscribeNotPayer() {
      return this.subscriptionWillEnd && !this.IS_CURRENT_USER_PAYER;
    },
    subscribeButtonTooltipText() {
      return this.disableSubscribeNotPayer ? this.$t("account.accountPlan.disabledSubscribeMessageNoPayer") : this.$t("account.accountPlan.paymentNeededTooltip");
    },
    hidePlanToggle() {
      return !(this.IS_CURRENT_USER_PAYER || isEmpty(this.PAYER));
    }
  }),
  mounted() {
    this.loadAccountDetails();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [ADD_SUBSCRIPTIONS, CANCEL_SUBSCRIPTIONS, LOAD_ACCOUNT_PLAN_DETAILS])), mapMutations("AccountPlanStore", [SET_SUBSCRIBING_CURRENT_ACCOUNT])), {}, {
    async loadAccountDetails() {
      if (!this.selectingPlan && this.SUBSCRIBING_CURRENT_ACCOUNT) return; // Another instance of the component has not finished the subscription process

      this.loading = true;
      await this.LOAD_ACCOUNT_PLAN_DETAILS();
      this.planDurationMonthly = this.CURRENT_ACCOUNT_PLAN_INTERVAL === "month";
      this.loading = false;
    },
    async handleSelectPlan(buttonText) {
      const payload = {
        accountsToPay: [this.CURRENT_USER_USERNAME],
        planDuration: this.planDurationMonthly ? "monthly" : "yearly"
      };
      this.selectingPlan = true;
      this.SET_SUBSCRIBING_CURRENT_ACCOUNT(true);
      const {
        succeeded
      } = await this.ADD_SUBSCRIPTIONS(payload);
      if (succeeded) {
        await delay(8000); //give some time to the backend to apply account changes
        await this.loadAccountDetails();
        showToast("info", "subscribedTourDoorrPlan");
      }
      this.SET_SUBSCRIBING_CURRENT_ACCOUNT(false);
      this.selectingPlan = false;
      Amplitude.logEvent(`Account Plan - Add Subscription Attempt Finished`, _objectSpread(_objectSpread({}, payload), {}, {
        buttonText,
        component: "plan-boxes"
      }));
    },
    async cancelPlan() {
      const payload = {
        accountsToCancel: [this.CURRENT_USER_USERNAME]
      };
      this.cancelingPlan = true;
      const {
        succeeded
      } = await this.CANCEL_SUBSCRIPTIONS(payload);
      if (succeeded) {
        await this.loadAccountDetails();
        showToast("success", "cancelledYourSubscription");
      }
      this.showCancelModal = false;
      this.cancelingPlan = false;
      Amplitude.logEvent("Account Plan - Cancel Subscription Attempt Finished", _objectSpread(_objectSpread({}, payload), {}, {
        component: "plan-boxes"
      }));
    },
    async handleCancelPlan() {
      this.showCancelModal = true;
      Amplitude.logEvent("Account Plan - Cancel Subscription Modal Opened", {
        component: "plan-boxes"
      });
    },
    handleChangePlanDuration() {
      this.planDurationMonthly = !this.planDurationMonthly;
      Amplitude.logEvent("Account Plan - Plan Duration Changed", {
        component: "plan-boxes",
        newPlanDuration: this.planDurationMonthly ? "monthly" : "yearly"
      });
    },
    getPlanAmount(plan, original = false) {
      var _plan$amount, _plan$amount$monthly, _plan$amount2, _plan$amount2$yearly;
      if (plan.name === PLAN_NAMES.FREE || !isObject(plan.amount)) return plan.amount;
      const amount = (this.planDurationMonthly ? (_plan$amount = plan.amount) == null ? void 0 : (_plan$amount$monthly = _plan$amount.monthly) == null ? void 0 : _plan$amount$monthly.amount : (_plan$amount2 = plan.amount) == null ? void 0 : (_plan$amount2$yearly = _plan$amount2.yearly) == null ? void 0 : _plan$amount2$yearly.amount) / 100;
      if (this.isCouponEmpty || original) return amount;
      const couponAmount = this.COUPON.amount / 100;
      switch (this.COUPON.type) {
        case "flat":
          if (couponAmount >= amount) return 0;
          return amount - couponAmount;
        case "percent":
          if (couponAmount >= 1) return 0;
          return amount * (1 - couponAmount);
      }
    },
    showCoupon({
      name
    }) {
      return !this.isCouponEmpty && name !== this.freePlanName;
    }
  })
});